import { Environment, Platform } from 'src/environment';
import { asyncLoadLibrary } from 'src/shared/utilities/asyncLoadLibrary';

export async function loadPerimeterX() {
  const { platform, environment, sensorId } = window.ghsConfiguration;
  if (platform === Platform.WEB) {
    window._sensorId = sensorId;

    const subdomain = environment === Environment.PROD ? 'sensor' : 'sensor-pp';

    await asyncLoadLibrary({
      id: 'perimeter-x-script',
      url: `https://${subdomain}.grubhub.com/${sensorId}/init.js`,
      attributes: { async: '' },
      isAppend: false,
    });
  }
}
